export const REQUEST_COMPANY = "REQUEST_COMPANY";
export const RECEIVED_COMPANY = "RECEIVED_COMPANY";
export const ERROR_COMPANY = "ERROR_COMPANY";

export const COMPANY_NONE = "COMPANY_NONE";
export const COMPANY_REQUESTING = "COMPANY_REQUESTING";
export const COMPANY_RECEIVED = "COMPANY_RECEIVED";
export const COMPANY_ERROR = "COMPANY_ERROR";
